var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"links"},[_vm._v(" © 上海哈特智康医疗技术有限公司 版权所有 2023-2024 服务热线:18621109920 "),_c('div',{staticClass:"copyright"},[_vm._v(" 备案号："),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("沪ICP备2024080457号-3")])])])])
}]

export { render, staticRenderFns }